import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { IAboutTeamValue } from '../interfaces/IAboutTeamValue';
import { IHoverStatistics } from '../interfaces/IHoverStatistics';

export const ABOUT_SECTION_VALUES = [
  {
    id: 0,
    image: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/about_hover_design_tools_homeowner.png"
        alt="about hover design tools for homeowners"
        objectFit="contain"
      />
    ),
    header: 'Design tools for homeowners',
    body: 'Select and see real products - roofing, siding, windows, and more - on a virtual 3D model of your home.',
    sub: 'Home improvement is a big deal - we take the guesswork out.',
  },
  {
    id: 1,
    image: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/about_hover_productivity.png"
        alt="about hover collaboration"
        objectFit="contain"
      />
    ),
    header: 'Productivity tools for professionals',
    body: 'Easier, more accurate measurements, automatic estimations, populated takeoffs, and direct ordering make your job easier.',
    sub: 'Get more done by working smarter, not harder.',
  },
  {
    id: 2,
    image: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/about_hover_collaboration.png"
        alt="about hover collaboration"
        objectFit="contain"
      />
    ),
    header: 'Collaboration at its best',
    body: 'Homeowners and pros can use our tools together - virtually or in person - to select materials, build estimates, and sign proposals.',
    sub: 'Transparent collaboration builds trust and results in an honest, fair deal for all.',
  },
];

export const TEAM_VALUES: IAboutTeamValue[] = [
  {
    id: 1,
    title: 'Think.',
    value: 'think',
    body: 'To evolve how home improvement happens for homeowners and professionals, we share our diverse perspectives, question assumptions, and push each other to innovate.',
    image: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/our_values_1.png"
        alt="our values think"
      />
    ),
  },
  {
    id: 2,
    title: 'Do.',
    value: 'do',
    body: 'We have a strong bias towards action. We work to transform great thinking into products that wow our customers, and we learn and adapt along the way.',
    image: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/our_values_2.png"
        alt="our values do"
      />
    ),
  },
  {
    id: 3,
    title: 'Serve.',
    value: 'serve',
    body: 'We are guided by the principles of servant leadership and transparency. Whether working with colleagues, serving our customers, or engaging in community work, empowering others through service is part of our core.',
    image: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/our_values_3.png"
        alt="our values serve"
      />
    ),
  },
];

export const ABOUT_HOVER_STATISTICS: IHoverStatistics[] = [
  {
    title: 'years of innovation',
    value: '11',
  },
  {
    value: '1.1 M',
    title: 'app downloads',
  },
  {
    title: 'hover dogs',
    value: '200+',
  },
];
